import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import AccountBalance from '@mui/icons-material/AccountBalance';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AlternateEmail from '@mui/icons-material/AlternateEmail';
import AttachMoney from '@mui/icons-material/AttachMoney';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Clear from '@mui/icons-material/Clear';
import ErrorIcon from '@mui/icons-material/Error';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Home from '@mui/icons-material/Home';
import Info from '@mui/icons-material/Info';
import Lock from '@mui/icons-material/Lock';
import Menu from '@mui/icons-material/Menu';
import MoreVert from '@mui/icons-material/MoreVert';
import Person from '@mui/icons-material/Person';
import Refresh from '@mui/icons-material/Refresh';
import Schedule from '@mui/icons-material/Schedule';
import Search from '@mui/icons-material/Search';
import ShowChart from '@mui/icons-material/ShowChart';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Warning from '@mui/icons-material/Warning';

/**
 * Maps the old Material Icons ligature names used across the app onto
 * @mui/icons-material components so we can drop the ligature font.
 */
const ICONS = {
  account_balance: AccountBalance,
  account_circle: AccountCircle,
  alternate_email: AlternateEmail,
  attach_money: AttachMoney,
  check_circle: CheckCircle,
  clear: Clear,
  error: ErrorIcon,
  expand_more: ExpandMore,
  home: Home,
  info: Info,
  lock: Lock,
  menu: Menu,
  more_vert: MoreVert,
  person: Person,
  refresh: Refresh,
  schedule: Schedule,
  search: Search,
  show_chart: ShowChart,
  trending_up: TrendingUp,
  warning: Warning,
} as const;

export type MaterialIconName = keyof typeof ICONS;

type MaterialIconProps = SvgIconProps & {
  name: MaterialIconName;
};

const MaterialIcon = ({ name, ...props }: MaterialIconProps) => {
  const IconComponent = ICONS[name];
  return <IconComponent {...props} />;
};

export default MaterialIcon;
